import React from 'react';
import IndustryPageTemplate from '../../components/IndustryPageTemplate';
import SEO from '../../components/SEO';

const TaxPreparation = () => {
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "How can Local Business Heroes help my tax preparation business?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Local Business Heroes helps tax preparation businesses capture more leads, automate follow-ups, reduce no-shows, and grow faster. Rated 4.9/5 by 1,200+ UK businesses."
        }
      },
      {
        "@type": "Question",
        "name": "How much does it cost for tax preparation businesses?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Plans start at £297/month with a 14-day trial for just £5. Most tax preparation businesses see ROI within the first month."
        }
      },
      {
        "@type": "Question",
        "name": "Do I need technical skills to use it?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "No. Local Business Heroes is designed for busy business owners with zero tech experience. Setup takes 5 minutes with UK-based support."
        }
      },
      {
        "@type": "Question",
        "name": "Will it work for my tax preparation business?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes. Local Business Heroes is specifically designed for local service businesses like tax preparation. Features include appointment scheduling, automated reminders, lead capture, and customer management."
        }
      }
    ]
  };

  const localBusinessSchema = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    "name": "CRM for Tax Preparation - Local Business Heroes",
    "applicationCategory": "BusinessApplication",
    "offers": {
      "@type": "Offer",
      "price": "297",
      "priceCurrency": "GBP"
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.9",
      "reviewCount": "1200"
    }
  };

  const breadcrumbs = [
    { name: "Home", url: "/" },
    { name: "Industries", url: "/industries" },
    { name: "Tax Preparation CRM", url: "/industries/tax-preparation" }
  ];

  const industryData = {
    name: 'Tax Preparation',
    title: 'Build Year-Round Client Base & Increase Advisory Revenue',
    subtitle: 'Automate tax season reminders, capture early filers, and grow your year-round advisory services',
    icon: '📊',
    challenges: [
      'Revenue concentrated in 3 months',
      'Clients wait until last minute',
      'Hard to get year-round advisory clients',
      'Document collection is chaotic',
      'One-time filers don\'t return'
    ],
    solutions: [
      'Early filing incentive automation',
      'Deadline reminder campaigns',
      'Advisory service upsell sequences',
      'Digital document collection',
      'Annual client retention programs'
    ],
    features: [
      'Client CRM with tax history',
      'Deadline reminder automation',
      'Secure document portal',
      'Refund tracking',
      'Quarterly advisory scheduling',
      'Audit support coordination',
      'Online appointment booking',
      'Review automation'
    ],
    results: [
      '50% clients file in January/February',
      '40% become year-round advisory clients',
      '95% annual client retention',
      '£7.5K average monthly revenue increase'
    ]
  };

  return (
    <>
      <SEO 
        title="CRM for Tax Preparation UK | Marketing Automation | Local Business Heroes"
        description="Rated 4.9/5. CRM and marketing automation for tax preparation businesses. Capture more leads, automate follow-up, grow faster. Start £5 trial today."
        keywords="CRM for tax preparation UK, tax preparation business software, tax preparation customer management, tax preparation lead generation UK"
        url="/industries/tax-preparation"
        schemaMarkup={[faqSchema, localBusinessSchema]}
        breadcrumbs={breadcrumbs}
      />
      <IndustryPageTemplate industry={industryData} />
    </>
  );
};

export default TaxPreparation;